import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, ViewEncapsulation, input, output } from '@angular/core';
import { Message, PaymentStatus } from '@domain/models';
import { getPaymentStatusUi } from '@shared/payment-status-ui';
import { PaymentDateExpiredResultComponent } from './payment-result-date-expired/payment-result-date-expired.component';
import { PaymentDuplicatedResultComponent } from './payment-result-duplicated/payment-result-duplicated.component';
import { PaymentGenericResultComponent } from './payment-result-generic/payment-result-generic.component';
import { PaymentManualReviewResultComponent } from './payment-result-manual-review/payment-result-manual-review.component';
import { PaymentNonPaymentImageResultComponent } from './payment-result-non-payment-image/payment-result-non-payment-image.component';
import { PaymentNotFoundResultComponent } from './payment-result-not-found/payment-result-not-found.component';
import { PaymentValidatedResultComponent } from './payment-result-validated/payment-result-validated.component';

@Component({
  selector: 'app-payment-result-message',
  imports: [
    CommonModule,
    PaymentDateExpiredResultComponent,
    PaymentDuplicatedResultComponent,
    PaymentGenericResultComponent,
    PaymentManualReviewResultComponent,
    PaymentNonPaymentImageResultComponent,
    PaymentNotFoundResultComponent,
    PaymentValidatedResultComponent
  ],
  templateUrl: './payment-result-message.component.html',
  styleUrl: './payment-result-message.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaymentResultMessageComponent {
  readonly message = input.required<Message>();
  readonly manualValidationRequested = output<Message>();

  status(): PaymentStatus | null {
    const message = this.message();
    return message.paymentStatus ?? this.asPaymentStatus(message.validation);
  }

  tone(): string {
    const status = this.status();
    return status ? getPaymentStatusUi(status).tone : 'warning';
  }

  private asPaymentStatus(value: unknown): PaymentStatus | null {
    const statuses: PaymentStatus[] = [
      'VALIDATED',
      'DUPLICATED',
      'NOT_FOUND',
      'DATE_EXPIRED',
      'NON_PAYMENT_IMAGE',
      'CHANNEL_NOT_ALLOWED',
      'MANUAL_REVIEW_REQUIRED',
      'USER_CONFIRMATION_REQUIRED',
      'ERROR_AGENT',
      'ERROR_PROCESSOR'
    ];
    return statuses.includes(value as PaymentStatus) ? value as PaymentStatus : null;
  }
}
